import { Container } from '@plone/components';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import Logo from '@kitconcept/volto-light-theme/components/Logo/Logo';
import complementary_logo from '@kitconcept/volto-light-theme/components/Header/complementary_logo';
import type { Content } from '@plone/types';
import { useLiveData } from '@kitconcept/volto-light-theme/helpers/useLiveData';
import type { SiteHeaderSettings } from '../../../types';

import isString from 'lodash/isString';
import config from '@plone/volto/registry';
import { createParagraph } from '@plone/volto-slate/utils';

const Colophon = ({ content }: { content: Content }) => {
  const logo = useLiveData<SiteHeaderSettings['logo']>(
    content,
    'voltolighttheme.header',
    'logo',
  );

  const complementary_logo = useLiveData<
  SiteHeaderSettings['complementary_logo']
  >(content, 'voltolighttheme.header', 'complementary_logo');

  const complementaryLogoSrc = complementary_logo?.data
  ? `data:${complementary_logo['content-type']};base64,${complementary_logo.data}`
  : flattenToAppURL(complementary_logo?.download);

  const footer_colophon_text = useLiveData<
    SiteFooterSettings['footer_colophon_text']
  >(content, 'voltolighttheme.footer', 'footer_colophon_text');

  const RenderSlateToHtml = config.widgets.views.widget.slate_richtext;

  const getValue = (value) => {
    // Previously this was a text field
    if (isString(value)) {
      return [createParagraph(value)];
    }
    return value;
  };


  return (
      <Container className="colophon">
      {footer_colophon_text && (
          <RenderSlateToHtml value={getValue(footer_colophon_text)} />
      )}

      {complementary_logo && (
          <div className="complementary-logo">
          <img src={complementaryLogoSrc} alt="complementary logo" />
          </div>
      )}
      </Container>

  );
};

export default Colophon;
